import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { PhoneInput as OriginalPhoneInput, defaultCountries, parseCountry } from 'react-international-phone';
import 'react-international-phone/style.css';
var countries = defaultCountries.filter(function (country) {
    console.log('parseCountry(country)', country);
    var iso2 = parseCountry(country).iso2;
    return ['gb', 'at', 'be', 'bg', 'hr', 'cz', 'dk', 'ee', 'fi', 'fr', 'de', 'gr', 'hu', 'ie', 'it', 'lv', 'lt', 'mt', 'nl', 'pl', 'pt', 'cy', 'ro', 'sk', 'si', 'es', 'se'].includes(iso2);
});
countries.push([
    "Other...",
    "xx",
    "",
]);
var customFlags = [
    {
        iso2: "xx",
        src: 'https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f30d.svg'
    }
];
export default function PhoneInput(_a) {
    var value = _a.value, onChange = _a.onChange;
    var phoneInput = useRef(null);
    function changeReactValue(input, value) {
        var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
        nativeInputValueSetter.call(input, value);
        var inputEvent = new Event("input", { bubbles: true });
        input.dispatchEvent(inputEvent);
    }
    useEffect(function () {
        var _a;
        (_a = phoneInput.current) === null || _a === void 0 ? void 0 : _a.addEventListener('paste', function (e) {
            var text = e.clipboardData.getData('text/plain');
            var cleanText = text.replace(/[^0-9+]/g, '');
            if (cleanText.match(/^\+44|^44/)) {
                e.preventDefault();
                cleanText = cleanText.replace(/^44/, '+44');
                cleanText = cleanText.replace(/^\+440+/, '+44');
                cleanText = cleanText.replace(/^\+44(\d{4})(\d+)/, '+44 $1 $2');
                // onChange(cleanText)
            }
            else {
                // 04567 123456
                if (cleanText.match(/^0(\d{4})(\d{6})/)) {
                    e.preventDefault();
                    cleanText = cleanText.replace(/^0(\d{4})(\d{6})/, '+44 $1 $2');
                    // onChange(cleanText)
                }
            }
            changeReactValue(phoneInput.current, cleanText);
            console.log('paste', text);
            console.log('paste>', cleanText);
        });
    }, [phoneInput]);
    return _jsx(OriginalPhoneInput, { ref: phoneInput, defaultCountry: 'gb', value: value !== null && value !== void 0 ? value : "", inputProps: {
            id: "telephone",
            placeholder: "+44 1234 123456"
        }, onChange: function (value, meta) {
            console.log('value', value, meta);
            var inputValue = meta.inputValue;
            inputValue = inputValue.replace(/^(\+\d+ )0+/, '$1');
            onChange(inputValue.trim());
            console.log('inputValue >', inputValue);
        }, placeholder: "+44 1234 123456", forceDialCode: true, countries: countries, flags: customFlags });
}
